import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n\n  max-width: 300px;\n  margin: 0 auto;\n\n  .ant-btn {\n    padding: 12px 20px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 150%;\n\n  svg {\n    width: 80px;\n    height: 50px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import FilledButton from "@/components/common/Button/FilledButton";
import Icon from "@/components/icon/Icon";
import { Empty } from "@/components/icon/IconList";
import { BOOKS_LANDING, EBOOKS_LANDING, PASSES_LANDING } from "@/settings/constant";
import Link from "next/link";
import useBooksOrderStore from "src/store/booksOrder";
import styled from "styled-components";
import { useBooks } from ".";
import BooksOrderProductItem from "./BooksOrderProductItem";
import { SourceTypeWithString } from "../../../api/product";
import { usePasses, useProductType } from "@/components/Package";
import { OrderCardContainer } from "../../Package/OrderComponents/PaymentCard";
const BooksOrderProductEmptyContainer = styled.div.withConfig({
    componentId: "sc-3155adbe-0"
})(_templateObject());
const BooksOrderProductEmptyImage = styled.div.withConfig({
    componentId: "sc-3155adbe-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_500);
const BooksOrderProducts = (param)=>{
    let { data  } = param;
    const { isBooks  } = useBooks();
    const { isPackages  } = usePasses();
    const items = useBooksOrderStore((state)=>state.items);
    const { productType  } = useProductType();
    return items ? items.length ? /*#__PURE__*/ _jsx(_Fragment, {
        children: items.map((item)=>/*#__PURE__*/ _jsx(BooksOrderProductItem, {
                ...item
            }, item.id))
    }) : /*#__PURE__*/ _jsx(OrderCardContainer, {
        children: /*#__PURE__*/ _jsxs(BooksOrderProductEmptyContainer, {
            children: [
                /*#__PURE__*/ _jsxs(BooksOrderProductEmptyImage, {
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            icon: Empty
                        }),
                        "담겨있는 ",
                        SourceTypeWithString[productType],
                        " 상품이 없습니다."
                    ]
                }),
                /*#__PURE__*/ _jsx(Link, {
                    href: isBooks ? BOOKS_LANDING : isPackages ? PASSES_LANDING : EBOOKS_LANDING,
                    children: /*#__PURE__*/ _jsxs(FilledButton, {
                        type: "text",
                        variant: "solid",
                        block: true,
                        children: [
                            SourceTypeWithString[productType],
                            " 상품 보러가기"
                        ]
                    })
                })
            ]
        })
    }) : null;
};
export default BooksOrderProducts;
